import * as axios from 'axios'
import ApiRoutes from '@/api/ApiRoutes'

export const parseList = response => {
  if (response.status !== 200 && response.status !== 204)
    throw Error(response.message)
  if (!response.data) return []
  let list = response.data
  if (typeof list !== 'object') {
    list = []
  }
  return list
}

const changePassword = async function(newPassword) {
  //try {
  const response = await axios.put(
    ApiRoutes.Auth.ChangePassword + newPassword.id,
    newPassword.newPassword,
  )
  let login = parseList(response)
  return login
  //} catch (e) {
  //  console.log(e)
  //  return e
  //}
}

const logon = async function(credentials, subdomain) {
  try {
    const response = await axios.post(
      `${ApiRoutes.Auth.Logon}?subdomain=${subdomain}`,
      credentials,
    )
    let login = parseList(response)
    return login
  } catch (e) {
    console.log(e)
  }
}

const logoff = async function() {
  try {
    const response = await axios.post(ApiRoutes.Auth.Logoff)
    let logoff = parseList(response)
    return logoff
  } catch (e) {
    console.log(e)
  }
}

const refreshLogon = async function() {
  try {
    const response = await axios.post(ApiRoutes.Auth.RefreshLogon)
    let login = parseList(response)
    return login
  } catch (e) {
    console.log(e)
  }
}

const getSettings = async function() {
  try {
    const response = await axios.get(ApiRoutes.Settings.GetAll)
    let settings = parseList(response)
    return settings
  } catch (e) {
    console.log(e)
  }
}

const getApps = async function() {
  try {
    const response = await axios.get(ApiRoutes.Applications.GetAll)
    let apps = parseList(response)
    return apps
  } catch (e) {
    console.log(e)
  }
}

const getUser = async function(userId) {
  try {
    const response = await axios.get(ApiRoutes.User.GetOne + userId)
    let apps = parseList(response)
    return apps
  } catch (e) {
    console.log(e)
  }
}

export const dataService = {
  logon,
  getSettings,
  getApps,
  getUser,
  logoff,
  refreshLogon,
  changePassword,
}
